import {Dispatch, FC, SetStateAction} from 'react'
import {Modal} from 'react-bootstrap'
import {KTSVG} from '../../../../../../../../_metronic/helpers'
// import {TableUploadBookingDetailsWrapper} from '../Tables/TableUploadBookingDetails'
import {GuestListModel} from '../../model'
import {TableUploadGuestShowDetailsWrapper} from '../table/TableUploadGuestShowDetails'

interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  bookingToShow: GuestListModel
}

const ModalDetailBooking: FC<Props> = ({show, setShow, bookingToShow}) => {
  const handleClose = () => {
    setShow(false)
  }
  return (
    <Modal
      className='modal fade'
      show={show}
      dialogClassName='modal-xl'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h5 className='modal-title'>Detalle de Personas no cargada</h5>

          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          {show && <TableUploadGuestShowDetailsWrapper bookingToShow={bookingToShow} />}
        </div>
      </div>
    </Modal>
  )
}

export {ModalDetailBooking}
